<p-splitButton
  [label]="label()"
  (onClick)="handleMainClick()"
  [model]="items()"
>
  @if (icon(); as icon) {
    <ng-template pTemplate="dropdownicon">
      <svg class="p-icon" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
        <use [attr.xlink:href]="icon"></use>
      </svg>
    </ng-template>
  }
</p-splitButton>
